import { Box, Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ReactNode } from 'react';

const StyledCard = styled(Card)(({ theme }) => ({
  height: '200px',
  minWidth: '260px',
  maxWidth: '375px',
  display: 'flex',
  flexDirection: 'column',
  transition: 'all 0.3s ease-in-out',
  border: '1px solid',
  borderColor: theme.palette.divider,
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows[8],
    borderColor: theme.palette.primary.main,
  },
}));

const StyledCardActionArea = styled(CardActionArea)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '24px',
});

export const ReportTypeCard = ({
  icon,
  title,
  description,
  onClick,
}: {
  icon: ReactNode;
  title: string;
  description: string;
  onClick: () => void;
}) => {
  return (
    <StyledCard>
      <StyledCardActionArea onClick={onClick}>
        <Box
          sx={{
            width: '80px',
            height: '80px',
            minWidth: '80px',
            minHeight: '80px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'secondary.main',
            color: 'common.white',
            fontSize: '40px',
            marginBottom: 2,
            flexShrink: 0,
            transition: 'all 0.3s ease-in-out',
            '&:hover': {
              backgroundColor: 'secondary.dark',
              transform: 'scale(1.1)',
            },
          }}
        >
          {icon}
        </Box>
        <CardContent sx={{ textAlign: 'center', padding: 0 }}>
          <Typography variant='h6' component='div' gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
            {title}
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            {description}
          </Typography>
        </CardContent>
      </StyledCardActionArea>
    </StyledCard>
  );
};
